module.exports = __webpack_public_path__ + "img/SetupAddProduct16.de049b18.png";